// The entrance animation lives in globals.css (`.hero-*` rules) so the content
// paints with the stylesheet instead of waiting for the JS bundle to execute.
const HeroSection = () => {
    return (
      <main
        id="hero"
        className="pt-[160px] sm:pt-[120px]   mx-auto   md:pt-[210px] lg:pt-[145px] px-4 sm:px-6 lg:px-20 pb-12 sm:pb-16 md:pb-20 lg:pb-24 max-w-[1340px] flex flex-col lg:flex-row items-center justify-between gap-8 sm:gap-12 md:gap-16 lg:gap-10 relative z-10"
      >
        {/* Left Content */}
        <div className="w-full lg:w-[780px] space-y-4 sm:space-y-5 md:space-y-5 text-left">
          {/* Heading with Owl */}
          <div className="hero-heading relative inline-block w-full">
            {/* Owl on top - responsive positioning */}
            <div className="hero-owl absolute -top-[40px] sm:-top-[50px] md:-top-[75px] lg:-top-[80px] right-[100px] sm:right-[30px] md:right-[300px] lg:right-[150px] z-10">
              <img
                src="/heroSection/HeadingTopImg.png"
                alt=""
                className="w-[60px] sm:w-[80px] md:w-[100px] lg:w-[110px] h-auto drop-shadow-[0_10px_20px_rgba(0,0,0,0.5)]"
              />
            </div>

            {/* Main Heading */}
            <h1
              className="flex flex-wrap items-center gap-3 sm:gap-4 md:gap-5 lg:gap-6"
              style={{
                fontSize: 'clamp(32px, 8vw, 72px)',
                lineHeight: 'clamp(40px, 10vw, 90px)',
                fontWeight: 500,
                letterSpacing: '0px',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Meet
              <span
                style={{ fontWeight: 700 }}
                className="flex items-center justify-center bg-[#8E57FA] rounded-[8px] sm:rounded-[10px] md:rounded-[12px] px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 lg:py-5 relative shadow-[0_20px_40px_rgba(139,92,246,0.3)] min-w-[180px] sm:min-w-[240px] md:min-w-[300px] lg:w-[361px] h-auto lg:h-[100px]"
              >
                Eddy AI
              </span>
            </h1>
          </div>

          {/* Home SVG */}
          <img
            src="/heroSection/Home.svg"
            alt=""
            className="hero-home-svg w-full max-w-[80px] md:max-w-[80px]"
          />

          {/* Description and Download Buttons */}
          <div className="space-y-6 sm:space-y-7 md:space-y-8 ">
            <p
              className="hero-description max-w-full lg:max-w-lg text-[#DCCBFD]"
              style={{
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 400,
                fontSize: 'clamp(14px, 3.5vw, 18px)',
                lineHeight: 'clamp(22px, 5vw, 30px)',
                letterSpacing: '1px',
              }}
            >
              Eddy AI is your AI study partner that delivers accurate answers, organised notes, and
              smart quizzes with just a quick scan.
            </p>

            {/* App Store Buttons */}
            <div className="flex flex-wrap gap-4 sm:gap-5 md:gap-6 pt-2">
              <a
                href="https://apps.apple.com/app/eddy-ai/id6758787935"
                className="hero-store-btn hover:scale-105 transition-transform active:scale-95 drop-shadow-xl"
              >
                <img
                  src="/heroSection/AppleStoreLabel.svg"
                  alt="App Store"
                  className="h-[40px] sm:h-[44px] md:h-[48px] w-auto"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.eddyai.scanner"
                className="hero-store-btn hover:scale-105 transition-transform active:scale-95 drop-shadow-xl"
              >
                <img
                  src="/heroSection/PlaystoreLabel.svg"
                  alt="Play Store"
                  className="h-[40px] sm:h-[44px] md:h-[48px] w-auto"
                />
              </a>
            </div>
          </div>

          {/* Features Icons and Trust Badge */}
          <div className="pt-2 sm:pt-3 md:pt-4 space-y-6 sm:space-y-8 md:space-y-10">
            {/* Feature Icons */}
            <div className="flex flex-wrap gap-5 sm:gap-5 md:gap-5">
              <img
                src="/heroSection/QuickScanIcon.svg"
                alt="Quick Scan"
                className="hero-feature-icon h-[35px] sm:h-[44px] md:h-[48px] w-auto hover:scale-105 transition-transform cursor-pointer"
              />
              <img
                src="/heroSection/GenerateQuizIcon.svg"
                alt="Generate Quiz"
                className="hero-feature-icon h-[35px] sm:h-[44px] md:h-[48px] w-auto hover:scale-105 transition-transform cursor-pointer"
              />
              <img
                src="/heroSection/GenerateNotesIcon.svg"
                alt="Generate Notes"
                className="hero-feature-icon h-[35px] sm:h-[44px] md:h-[48px] w-auto hover:scale-105 transition-transform cursor-pointer"
              />
            </div>

            {/* Trust Badge */}
            <p
              className="hero-trust text-[#DCCBFD] font-normal tracking-wide pl-1"
              style={{
                fontSize: 'clamp(14px, 3.5vw, 18px)',
                lineHeight: '1.5',
              }}
            >
              Trusted by thousands of Students globally
            </p>
          </div>
        </div>

        {/* Right Content - iPhone Mockup with Video */}
        <div className="hero-phone hidden md:hidden lg:flex w-full lg:w-1/2 justify-end  items-center">
          <div className="relative">
            {/* Glow effect */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] bg-[#8E57FA]/20 blur-[100px] rounded-full pointer-events-none" />

            {/* iPhone Frame */}
            <div
              className="relative z-20 drop-shadow-[0_20px_40px_rgba(0,0,0,0.4)] lg:[filter:drop-shadow(0_40px_60px_rgba(0,0,0,0.5))_drop-shadow(0_20px_45px_rgba(139,92,246,0.35))]"
              style={{
                width: 'clamp(190px, 20vw, 240px)',
                aspectRatio: '390 / 844',
              }}
            >
              {/* Phone outer body */}
              <div
                className="absolute inset-0 rounded-[32px] sm:rounded-[36px] md:rounded-[40px] border-[3px] border-[#3a3a42] bg-[#1a1a1e]"
                style={{
                  boxShadow:
                    'inset 0 0 0 1px rgba(255,255,255,0.08), 0 0 0 1px rgba(255,255,255,0.18)',
                }}
              />

              {/* Side buttons - positions in % so they scale with the phone width */}
              <div className="absolute -left-[2px] top-[21.5%] h-[3.6%] w-[3px] rounded-l-[2px] bg-[#3a3a42]" />
              <div className="absolute -left-[2px] top-[27.5%] h-[7.1%] w-[3px] rounded-l-[2px] bg-[#3a3a42]" />
              <div className="absolute -left-[2px] top-[36.7%] h-[7.1%] w-[3px] rounded-l-[2px] bg-[#3a3a42]" />
              <div className="absolute -right-[2px] top-[30.4%] h-[11.5%] w-[3px] rounded-r-[2px] bg-[#3a3a42]" />

              {/* Screen area - inset creates the bezel; border is the bezel/screen hairline */}
              <div className="absolute inset-[12px] rounded-[20px] sm:rounded-[24px] md:rounded-[28px] overflow-hidden border border-white/10 bg-[#8E57FA]">
                {/* Video */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                  poster="/heroSection/MobileGradient.png"
                >
                  <source
                    src="https://res.cloudinary.com/dr0ndlnsz/video/upload/v1770815944/Screen_wsrall.mp4"
                    type="video/mp4"
                  />
                  {/* Fallback to the original static image */}
                  <img
                    src="/heroSection/Mobile.svg"
                    alt="Eddy AI Mobile App"
                    className="w-full h-full object-cover"
                  />
                </video>
              </div>

              {/* Dynamic Island / Notch */}
              <div className="absolute top-[16px] sm:top-[17px] md:top-[18px] left-1/2 -translate-x-1/2 z-30 w-[70px] sm:w-[80px] md:w-[90px] h-[20px] sm:h-[22px] md:h-[25px] bg-[#1a1a1e] rounded-full" />

              {/* Home Indicator */}
              <div className="absolute bottom-[16px] sm:bottom-[18px] left-1/2 -translate-x-1/2 z-30 w-[60px] sm:w-[70px] md:w-[80px] h-[3px] sm:h-[4px] bg-white/30 rounded-full" />
            </div>
          </div>
        </div>
      </main>
    );
};

export default HeroSection;
